/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

console.log('fire custom')



function overrideSearchPlaceholder(){
  return
    console.log('starting')
    var placeholderOptions = [
        'Search By Color',
        'Search By Style',
        'Search By Brand',
        'Search By Apparel Type'
    ];

    var position = Math.floor(Math.random() * 3);

    // var searchBoxes = document.getElementsByClassName('boost-pfs-search-box')
    var searchBoxes = document.getElementsByClassName('search-bar__input')
    
    for(var x = 0; x < searchBoxes.length; x++){
        searchBoxes[x].placeholder = placeholderOptions[position]
    }

}


function testOverflow(elem){           
    if (elem.offsetWidth < elem.scrollWidth) {
        // your element have overflow
        return true; 
    } else {
        // your element doesn't have overflow
        return false;
    }
}

function testAllTables(){
    var tables = document.getElementsByClassName('table-wrapper')

    console.log('test tables')

    for(var p = 0; p < tables.length; p++){        
        var overflow = testOverflow(tables[p])
        if(overflow){
            console.log('overflow!')
            tables[p].classList.add('overflow-show')
        }
        else{
            console.log('no overflow')
            tables[p].classList.remove('overflow-show')   
        }
    }
}

document.addEventListener('DOMContentLoaded', (event) => {
    testAllTables()    
});

window.addEventListener('resize', function(){
    clearTimeout(window.resizedFinished);
    window.resizedFinished = setTimeout(function(){
        console.log('testing on resize')
        testAllTables()
    }, 250);
})


function deferScripts() {
    if (window.jQuery) {
    // if (window.jQuery && window.jQ && window.jQuery341 ) {
        console.log('jq ready')
        if(jQuery('#custom_logo_file').length > 0){
            init_logo_script()    
        }        
    } else {
        console.log('not yet')
        setTimeout(function() { deferScripts() }, 50);
    }
}
overrideSearchPlaceholder()
deferScripts()
